<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-layout row wrap class="mt-3">
        <v-flex xs12 sm6 md3>
          <p class="grey--text caption mb-1">Datum:</p>
          <strong>{{info.datum | formatDate}}</strong>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <p class="grey--text caption mb-1">Klient:</p>
          <router-link :to="{ path: '/klienti/' + info.osoba.id }" target="_blank">
            <strong>{{info.osoba.nazev_osoby}}</strong>
          </router-link>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <p class="grey--text caption mb-1">Částka:</p>
          <strong>{{info.castka | formatMoney}} {{info.mena.zkratka}}</strong>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="mt-5">
        <v-flex xs12>
          <h3>Rozdělení provize mezi spolupracovníky:</h3>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="mt-3">
        <v-flex xs12>
          <div class="table-border__radius elevation-1">
            <v-data-table
              :headers="headers"
              :items="items"
              hide-actions
              item-key="i"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <router-link :to="{ path: '/spolupracovnici/' + props.item.spolupracovnik.id }" target="_blank">
                    {{ props.item.spolupracovnik.nazev_osoby }}
                  </router-link>
                </td>
                <td>{{ props.item.pozice }}</td>
                <td class="text-xs-right">{{ props.item.kredity }}</td>
                <td class="text-xs-right">{{ props.item.hodnota_kreditu }}</td>
                <td class="text-xs-right">{{ props.item.provize | formatMoney }} Kč</td>
              </template>
            </v-data-table>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="mt-5">
        <v-flex xs12>
          <p>Celkem: <strong>{{celkem | formatMoney}} Kč</strong></p>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      headers: [
        { text: 'Spolupracovník', value: 'spolupracovnik', sortable: false },
        { text: 'Pozice', value: 'pozice', sortable: false },
        { text: 'Kredity', value: 'kredity', sortable: false, align: "right" },
        { text: 'Hodnota kreditu', value: 'hodnota_kreditu', sortable: false, align: "right" },
        { text: 'Provize', value: 'provize', sortable: false, align: "right" }
      ],
      info: null,
      items: [],
      celkem: null
    }
  },
  props: {
    id: String
  },
  mounted () {
    this.load();
  },
  methods: {
    gotoall () {
      this.$router.push({ path: "/admin/obchody-a-provize" });
    },
    load () {
      window.API.get("prehledy/obchody-provize/" + this.$props.id).then(function(b) {
        this.info = b.info;
        this.items = b.polozky;
        this.celkem = b.celkem;
        this.loading = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Admin/ObchodyProvizeDetailContent.vue